
import React from "react";
import { Shield, Heart, Gift } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Card, CardContent } from "@/components/ui/card";

const WhyLegatia = () => {
  const { language } = useLanguage();
  
  const content = {
    fr: {
      title: "Pourquoi Legatia ?",
      secureFuture: {
        title: "Un cadeau pour chaque moment clé",
        description: "Une réserve financière qui se débloque pour les études, le premier achat immobilier ou le mariage."
      },
      shareLove: {
        title: "Messages personnalisés",
        description: "Accompagnez votre cadeau de messages qui se dévoilent lors des étapes importantes de leur vie."
      },
      createLegacy: {
        title: "Un impact durable",
        description: "Votre soutien tangible au moment exact où ils en ont besoin dans leur parcours."
      }
    },
    en: {
      title: "Why Legatia?",
      secureFuture: {
        title: "A Gift for Every Milestone",
        description: "A financial reserve that unlocks for education, first home purchase, or wedding."
      },
      shareLove: {
        title: "Personalized Messages",
        description: "Accompany your gift with messages that reveal themselves during important stages of their life."
      },
      createLegacy: {
        title: "Lasting Impact",
        description: "Your tangible support at the exact moment they need it in their journey."
      }
    },
    de: {
      title: "Warum Legatia?",
      secureFuture: {
        title: "Ein Geschenk für jeden Meilenstein",
        description: "Eine finanzielle Reserve, die für Bildung, den ersten Hauskauf oder die Hochzeit freigeschaltet wird."
      },
      shareLove: {
        title: "Persönliche Botschaften",
        description: "Begleiten Sie Ihr Geschenk mit Nachrichten, die sich während wichtiger Lebensphasen offenbaren."
      },
      createLegacy: {
        title: "Nachhaltige Wirkung",
        description: "Ihre greifbare Unterstützung genau in dem Moment, in dem sie sie auf ihrem Weg benötigen."
      }
    }
  };
  
  const textContent = content[language];

  return (
    <section className="py-20 px-4 bg-legatia-light">
      <div className="container mx-auto max-w-6xl">
        <h2 className="section-title text-center mb-16">
          {textContent.title}
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          <Card className="bg-white border-none shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
            <div className="h-2 bg-gradient-to-r from-growth to-growth"></div>
            <CardContent className="pt-8">
              <div className="bg-growth/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-6">
                <Shield className="h-8 w-8 text-growth" />
              </div>
              <h3 className="text-xl font-bold mb-4">{textContent.secureFuture.title}</h3>
              <p className="text-gray-600">{textContent.secureFuture.description}</p>
            </CardContent>
          </Card>
          
          <Card className="bg-white border-none shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
            <div className="h-2 bg-gradient-to-r from-tenderness to-tenderness"></div>
            <CardContent className="pt-8">
              <div className="bg-tenderness/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-6">
                <Heart className="h-8 w-8 text-tenderness" />
              </div>
              <h3 className="text-xl font-bold mb-4">{textContent.shareLove.title}</h3>
              <p className="text-gray-600">{textContent.shareLove.description}</p>
            </CardContent>
          </Card>
          
          <Card className="bg-white border-none shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
            <div className="h-2 bg-gradient-to-r from-sunrise to-sunrise"></div>
            <CardContent className="pt-8">
              <div className="bg-sunrise/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-6">
                <Gift className="h-8 w-8 text-sunrise" />
              </div>
              <h3 className="text-xl font-bold mb-4">{textContent.createLegacy.title}</h3>
              <p className="text-gray-600">{textContent.createLegacy.description}</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default WhyLegatia;
